import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import Register from '@/pages/Register'
import Forget from '@/pages/Forget'
import UserCenter from '@/pages/UserCenter'
import UserInfo from '@/pages/UserInfo'
import Report from '@/pages/Report'
import ReportDetail from '@/pages/ReportDetail'
import WXReport from '@/pages/WXReport'
import NewWXReport from '@/pages/NewWXReport'
import WXReportDeatil from '@/pages/WXReportDetail'
import SkinGauge from '@/pages/SkinGauge'
import Test from '@/pages/Test'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Doctor/Login',
      name: 'home',
      component: Login
    },
    {
      path: '/Doctor/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/Doctor/Forget',
      name: 'Forget',
      component: Forget
    },
    {
      path: '/Doctor/UserCenter',
      name: 'UserCenter',
      component: UserCenter
    },
    {
      path: '/Doctor/UserInfo',
      name: 'UserInfo',
      component: UserInfo
    },
    {
      path: '/Report/Medical',
      name: 'Report',
      component: Report
    },
    {
      path: '/Report/MedicalInfo',
      name: 'ReportDetail',
      component: ReportDetail
    },
    {
      path: '/Report/Pifu_play',
      name: 'WXReport',
      component: WXReport
    },
    {
      path: '/Report/pifu_profes',
      name: 'WXReportDetail',
      component: WXReportDeatil
    },
    {
      path: '/Report/newPifu_play',
      name: 'NewWXReport',
      component: NewWXReport
    },
    {
      path: '/Report/SkinGauge',
      name: 'SkinGauge',
      component: SkinGauge
    },
    {
      path: '/Report/Test',
      name: 'Test',
      component: Test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js